import React, { useEffect, useState } from "react";
import "./StaticPagesMobile.scss";
import { useRouteMatch } from "react-router";
import {
    IonButton,
    IonPage,
} from "@ionic/react";
import { BUSINESS_CONFIG,PRIVACY_POLICY } from "../../../../clientConfig";
import { setPageTitle } from "helpers/seoHelper";
import { PageWrapperComponent } from "modules/common";
import { HeaderComponent } from "modules/common";
 
const PrivacyPolicy = () => {
    useEffect(() => {
        setPageTitle("Privacy Policy");
    }, []);
 
 
    const getTitle = () => {
        return "Privacy Policy"
    }
    return (
        <>
            <IonPage className="ionPage">
                <HeaderComponent pageTitle={getTitle()}  hideSearch hideLogo={true} hideMenuButton />
                <PageWrapperComponent>
                    <div className="body-text">{PRIVACY_POLICY}</div>
                </PageWrapperComponent>
            </IonPage>
        </>
    )
}
export default PrivacyPolicy;